import { Menu, MenuItem } from '@mui/material';
import { MainTab } from '../../../store/mainTabsStore';

type Props = {
  open: boolean;
  clientX: number;
  clientY: number;
  onCloseClick: (tab: MainTab) => void;
  onCloseOthersClick: (tab: MainTab) => void;
  onCloseSavedClick: (tab: MainTab) => void;
  onCloseAllClick: (tab: MainTab) => void;
  onCloseContextMenu: () => void;
  tabClicked: MainTab;
};

function ContextMenu({
  open,
  clientX,
  clientY,
  onCloseClick,
  onCloseOthersClick,
  onCloseSavedClick,
  onCloseAllClick,
  onCloseContextMenu,
  tabClicked,
}: Props) {
  return (
    <Menu
      open={open}
      onClose={onCloseContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={open ? { top: clientY, left: clientX } : undefined}
    >
      <MenuItem
        onClick={() => {
          onCloseClick(tabClicked);
          onCloseContextMenu();
        }}
      >
        Close
      </MenuItem>
      <MenuItem
        onClick={() => {
          onCloseOthersClick(tabClicked);
          onCloseContextMenu();
        }}
      >
        Close others
      </MenuItem>
      <MenuItem
        onClick={() => {
          onCloseSavedClick(tabClicked);
          onCloseContextMenu();
        }}
      >
        Close saved
      </MenuItem>
      <MenuItem
        onClick={() => {
          onCloseAllClick(tabClicked);
          onCloseContextMenu();
        }}
      >
        Close All
      </MenuItem>
    </Menu>
  );
}

export default ContextMenu;
